// import * as React, from "react";
import React, { useEffect, useState, useRef } from "react";

// React Bootstrap
import { Modal, Tab, Nav, Offcanvas } from 'react-bootstrap';


// Import Slider
import Slider from "react-slick";


// Import Components
import Header from "../components/HeaderComponent";
import LineChart from "../components/LineChart";
import SelectDropdown from "../components/SelectDropdown";
import CoinSelectDropdown from "../components/CoinSelectDropdown";

// Import Images
import managingImage from '../assets/images/manage-crypto-img.svg'
import bitcoinImage from '../assets/images/bitcoin-logo.svg'
import etheriumImage from '../assets/images/etherium-logo.svg'
import qrcodeImage from '../assets/images/qrcode-img.png'
import whiteLogo from '../assets/images/logo-white.svg'
import usdLogo from '../assets/images/usd-logo.svg'
import euroLogo from '../assets/images/euro-logo.svg'
import xdcLogo from '../assets/images/xdc-logo.png'
import usdtLogo from '../assets/images/usdt-logo.svg'

// Import Icons
import plusIcon from '../assets/images/icons/plus-white-icon.svg'
import searchIcon from '../assets/images/icons/search-gray-icon.svg'
import arrowDownIcon from '../assets/images/icons/arrow-angle-down-small-icon.svg'
import btcGrayIcon from '../assets/images/icons/btc-gray-icon.svg'
import crossIcon from '../assets/images/icons/cross-gray-icon.svg'
import walletIcon from '../assets/images/icons/wallet-gray-icon.svg'
import walletDarkIcon from '../assets/images/icons/wallet-dark-gray-icon.svg'
import usdcIcon from '../assets/images/icons/usdc-coin-icon.svg'
import btcTagIcon from '../assets/images/icons/btc-tag-icon.svg'
import bankIcon from '../assets/images/icons/back-icon.svg'
import uploadFileIcon from '../assets/images/icons/upload-file-icon.svg'
import darkLogo from "../assets/images/dark-logo.svg";
import eyeHideIcon from "../assets/images/icons/eye-hide-icon.svg";
import eyeViewIcon from "../assets/images/icons/eye-view-icon.svg";
import { Link } from "react-router-dom";



function DemoPage() {
    const [createWallet, setCreateWallet] = useState(false);
    const [whitelistCoinSelect, setWhitelistCoinSelect] = useState('crypto');

    const [depositShow, setDeposit] = useState(false);
    const [withdrawShow, setWithdraw] = useState(false);

    const [assetsDepositWalletShow, setAssetsDepositWallet] = useState(false);
    const [walletsDepositWalletShow, setWalletsDepositWallet] = useState(false);
    const [fiatDepositShow, setFiatDepositShow] = useState(false);
    const [uploadProofShow, setUploadProofShow] = useState(false);
    const [assetsWithdrawShow, setAssetsWithdrawShow] = useState(false);
    const [assetsWithdrawFundsShow, setAssetsWithdrawFundsShow] = useState(false);
    const [addWhitelistWalletShow, setAddWhitelistWallet] = useState(false);

    // Mobile popup States
    const [walletsDepositWalletMobileShow, setWalletsDepositWalletMobile] = useState(false);
    const [fiatDepositMobileShow, setFiatDepositMobileShow] = useState(false);
    const [uploadProofMobileShow, setUploadProofMobileShow] = useState(false);
    const [assetsDepositWalletMobileShow, setAssetsDepositWalletMobile] = useState(false);
    const [assetsWithdrawMobileShow, setAssetsWithdrawMobileShow] = useState(false);
    const [assetsWithdrawFundsMobileShow, setAssetsWithdrawFundsMobileShow] = useState(false);

    // Slider Code Start
    const assetSlider = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 3.5,
        slidesToScroll: 3.5,
        autoplaySpeed: 2000,
        autoplay: false,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 2.3,
                    slidesToScroll: 1,
                    initialSlide: 1
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2.4,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 4.4,
                    slidesToScroll: 1,
                    initialSlide: 1
                }
            },

            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2.4,
                    slidesToScroll: 1
                }
            }
        ]
    };
    // Slider Code Start



    // Custom Select Wallet Start
    const selectWalletOptions = [
        { label: "John’s BTC Wallet", icon: walletIcon },
        { label: "Owais BTC Wallet", icon: walletIcon },
        { label: "Raj BTC Wallet", icon: walletIcon },
    ];

    const onSelectWallet = (value) => {
        // console.log("Selected Value:", value);
    };
    // Custom Select Wallet End



    // Custom Select Coin Start
    const selectCoinOptions = [
        { label: "Bitcoin", shortName: "BTC", icon: bitcoinImage },
        { label: "Etherium", shortName: "ETH", icon: etheriumImage },
    ];
    const onSelectCoin = (value) => {
        // console.log("Selected Value:", value);
    };
    // Custom Select Coin End


    // Add Whitelist Wallet Select Coin Start
    const selectAddWhitelistWalletOptions = [
        { label: "Bitcoin", shortName: "BTC", icon: bitcoinImage },
        { label: "Etherium", shortName: "ETH", icon: etheriumImage },
        { label: "USD", shortName: "USD", icon: usdLogo },
        { label: "EURO", shortName: "EURO", icon: euroLogo },
    ];
    const onSelectAddWhitelistWallet = (value) => {
        if (value.shortName == 'BTC' || value.shortName == 'ETH') {
            // setWhitelistCoinSelect('crypto');
            // console.log(whitelistCoinSelect, "admin 1");
        } else {
            // setWhitelistCoinSelect('fiat');
            // console.log(whitelistCoinSelect, "admin 2");
        }
    };




    // Add Whitelist Wallet Select Coin End



    // Custom Select Coin Start
    const selectWalletCoinOptions = [
        { label: "John’s BTC Wallet", shortName: "Address : 0x2344383822289399c8388324", icon: walletIcon },
        { label: "Raj ETH Wallet", shortName: "Address : 0x2344383348489399c8388234", icon: walletIcon },
        { label: "Aries ETH Wallet", shortName: "Address : 0x23443838482349399c8384554", icon: walletIcon },
        { label: "Owais BTC Wallet", shortName: "Address : 0x23443838443489399c8388544", icon: walletIcon },
    ];

    const onSelectWalletCoin = (value) => {
        // console.log("Selected Value:", value);
    };
    // Custom Select Coin End




    // Custom Select Wallet Start
    const selectBanksOptions = [
        { label: "182828382923983 - Bank Of America", icon: bankIcon },
        { label: "182828382923983 - Bank Of London", icon: bankIcon },
        { label: "182828382923983 - Bank Of India", icon: bankIcon },
        { label: "182828382923983 - Bank Of Pakistan", icon: bankIcon },
    ];

    const onSelectBanks = (value) => {
        // console.log("Selected Value:", value);
    };
    // Custom Select Wallet End




    // Deposit Modal Start
    const onDepositClose = () => setDeposit(false);
    const onDepositShow = () => setDeposit(true);
    // Deposit Modal Start




    // Withdraw Modal Start
    const onWithdrawClose = () => setWithdraw(false);
    const onWithdrawShow = () => setWithdraw(true);
    // Withdraw Modal End




    // Assets Deposit Wallet Modal Start
    const onAssetsDepositWalletClose = () => setAssetsDepositWallet(false);
    const onAssetsDepositWalletShow = () => setAssetsDepositWallet(true);
    // Assets Deposit Wallet Modal End

    // Assets Deposit Wallet Mobile Modal Start
    const onAssetsDepositWalletMobileClose = () => setAssetsDepositWalletMobile(false);
    const onAssetsDepositWalletMobileShow = () => setAssetsDepositWalletMobile(true);
    // Assets Deposit Wallet Mobile Modal End




    // Assets Deposit Wallet Modal Start
    const onWalletsDepositWalletClose = () => setWalletsDepositWallet(false);
    const onWalletsDepositWalletShow = () => setWalletsDepositWallet(true);
    // Assets Deposit Wallet Modal End

    // Assets Deposit Wallet Mobile Modal Start
    const onWalletsDepositWalletMobileClose = () => setWalletsDepositWalletMobile(false);
    const onWalletsDepositWalletMobileShow = () => setWalletsDepositWalletMobile(true);
    // Assets Deposit Wallet Modal Mobile End




    // Fiat Deposit Modal Start
    const onFiatDepositClose = () => {
        setFiatDepositShow(false);
    }
    const onFiatDepositShow = () => {
        setFiatDepositShow(true);
        setWalletsDepositWallet(false);
    }
    // Fiat Deposit Modal End


    // Fiat Deposit Mobile Modal Start
    const onFiatDepositMobileClose = () => {
        setFiatDepositMobileShow(false);
    }
    const onFiatDepositMobileShow = () => {
        setFiatDepositMobileShow(true);
        setWalletsDepositWalletMobile(false);
    }
    // Fiat Deposit Modal Mobile End





    // Fiat Deposit Modal Start
    const onUploadProofClose = () => {
        setUploadProofShow(false);
    }
    const onUploadProofShow = () => {
        setUploadProofShow(true);
        setFiatDepositShow(false);
    }
    // Fiat Deposit Modal End

    // Fiat Deposit Mobile Modal Start
    const onUploadProofMobileClose = () => {
        setUploadProofMobileShow(false);
    }
    const onUploadProofMobileShow = () => {
        setUploadProofMobileShow(true);
        setFiatDepositMobileShow(false);
    }
    // Fiat Deposit Mobile Modal End




    // Assets Withdraw Modal Start
    const onAssetsWithdrawClose = () => {
        setAssetsWithdrawShow(false);
    }
    const onAssetsWithdrawShow = () => {
        setAssetsWithdrawShow(true);
    }
    // Assets Withdraw Modal End

    // Assets Withdraw Mobile Modal Start
    const onAssetsWithdrawMobileClose = () => {
        setAssetsWithdrawMobileShow(false);
    }
    const onAssetsWithdrawMobileShow = () => {
        setAssetsWithdrawMobileShow(true);
    }
    // Assets Withdraw Mobile Modal End




    // Assets Withdraw Modal Start
    const onAssetsWithdrawFundsClose = () => {
        setAssetsWithdrawFundsShow(false);
    }
    const onAssetsWithdrawFundsShow = () => {
        setAssetsWithdrawFundsShow(true);
        setAssetsWithdrawShow(false);
    }
    // Assets Withdraw Modal End

    // Assets Withdraw Mobile Modal Start
    const onAssetsWithdrawFundsMobileClose = () => {
        setAssetsWithdrawFundsMobileShow(false);
    }
    const onAssetsWithdrawFundsMobileShow = () => {
        setAssetsWithdrawFundsMobileShow(true);
        setAssetsWithdrawMobileShow(false);
    }
    // Assets Withdraw Mobile Modal End


    // Add Whitelist Wallet Modal Start
    const onAddWhitelistWalletClose = () => {
        setAddWhitelistWallet(false);
    }
    const onAddWhitelistWalletShow = () => {
        setAddWhitelistWallet(true);
    }
    // Add Whitelist Wallet Modal End



    // Custom Code Start
    const [wallets, setWallets] = useState([
        { id: 1, name: "John’s BTC Wallet" },
        { id: 2, name: "Raj ETH Wallet" },
        { id: 2, name: "Aries ETH Wallet" },
        { id: 2, name: "Owais BTC Wallet" },
        { id: 2, name: "Bimla ETH Wallet" },
    ]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showQRCode, setShowQRCode] = useState(false);

    // Filtered wallets based on search query
    const filteredWallets = wallets.filter(wallet =>
        wallet.name.toLowerCase().includes(searchQuery.toLowerCase())
    );
    const onCreateWallet = () => {
        setCreateWallet(true);
    }
    // Custom Code End


    // Otp Code
    const [otp, setOtp] = useState("");
    const handleOtpChange = (e) => {
        const value = e.target.value.replace(/\D/g, ""); // Allow only digits
        if (value.length <= 4) {
            setOtp(value);
        }
    };

    const handleOtpPaste = (e) => {
        e.preventDefault();
        const pasteData = e.clipboardData.getData("Text").replace(/\D/g, ""); // Extract digits from pasted data
        if (pasteData.length == 4) {
            setOtp(pasteData);
        }
    };
    return (
        <div className='home-page'>
            <Header />
            <section className="sec-banner">
                <div className="container-fluid">
                    <div className="banner-wrapper">
                        <div className="top-notch-wrapper">
                            <span className="top-notch"></span>
                            <a href="#" className="logo">
                                <img src={whiteLogo} alt="logo" />
                            </a>
                        </div>
                        <div className="container">
                            {(!createWallet) &&
                                <div className="crypto-card">
                                    <div className="content-wrapper">
                                        <h1>Start Managing Your Crypto Securely</h1>
                                        <h3 className="h-font f-17 w-500">Create or link a wallet to access secure custody, transactions, and monitoring. Your crypto journey starts here.</h3>
                                        <ul className="btn-list">
                                            <li>
                                                {/*<a href="#" className="btn-style icon" onClick={onCreateWallet}>*/}
                                                <a href="#" className="btn-style icon"><img src={plusIcon} alt="icon" /> Create Wallet</a>
                                            </li>
                                            <li>
                                                <Link to="/otc-trade" className="btn-style icon">OTC Trade</Link>
                                            </li>
                                            <li>
                                                <Link to="/transaction-history" className="btn-style icon">Transaction History</Link>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="img-wrapper">
                                        <img src={managingImage} alt="img" />
                                    </div>
                                </div>
                            }
                            {(createWallet) &&
                                <div className="row">
                                    <div className="col-lg-6 col-md-12">
                                        <div className="value-asset-card">
                                            <div className="row">
                                                <div className="col-xl-4 col-lg-5 col-md-4 align-self-end">
                                                    <div className="content-wrapper">
                                                        <h3 className="f-24 h-font">Total Value of <br />
                                                            your Assets</h3>
                                                        <strong>$ 23,493</strong>
                                                    </div>
                                                </div>
                                                <div className="col-xl-8 col-lg-7 col-md-8 align-self-end">
                                                    <div className="chart-wrapper">
                                                        <LineChart />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-12">
                                        <div className="your-asset-card">
                                            <h3 className="f-20">Your Assets</h3>
                                            <div className="asset-slider">
                                                <Slider {...assetSlider}>
                                                    <div className="your-asset-card">
                                                        <div className="icon">
                                                            <img src={btcGrayIcon} alt="icon" />
                                                        </div>
                                                        <div className="content">
                                                            <h3 className="h-font f-24 title">1.34 BTC</h3>
                                                            <h3 className="h-font f-20">$2838.3</h3>
                                                        </div>
                                                    </div>
                                                    <div className="your-asset-card">
                                                        <div className="icon">
                                                            <img src={btcGrayIcon} alt="icon" />
                                                        </div>
                                                        <div className="content">
                                                            <h3 className="h-font f-24 title">1.34 BTC</h3>
                                                            <h3 className="h-font f-20">$2838.3</h3>
                                                        </div>
                                                    </div>
                                                    <div className="your-asset-card">
                                                        <div className="icon">
                                                            <img src={btcGrayIcon} alt="icon" />
                                                        </div>
                                                        <div className="content">
                                                            <h3 className="h-font f-24 title">1.34 BTC</h3>
                                                            <h3 className="h-font f-20">$2838.3</h3>
                                                        </div>
                                                    </div>

                                                    <div className="your-asset-card">
                                                        <div className="icon">
                                                            <img src={btcGrayIcon} alt="icon" />
                                                        </div>
                                                        <div className="content">
                                                            <h3 className="h-font f-24 title">1.34 BTC</h3>
                                                            <h3 className="h-font f-20">$2838.3</h3>
                                                        </div>
                                                    </div>
                                                    <div className="your-asset-card">
                                                        <div className="icon">
                                                            <img src={btcGrayIcon} alt="icon" />
                                                        </div>
                                                        <div className="content">
                                                            <h3 className="h-font f-24 title">1.34 BTC</h3>
                                                            <h3 className="h-font f-20">$2838.3</h3>
                                                        </div>
                                                    </div>
                                                    <div className="your-asset-card">
                                                        <div className="icon">
                                                            <img src={btcGrayIcon} alt="icon" />
                                                        </div>
                                                        <div className="content">
                                                            <h3 className="h-font f-24 title">1.34 BTC</h3>
                                                            <h3 className="h-font f-20">$2838.3</h3>
                                                        </div>
                                                    </div>

                                                    <div className="your-asset-card">
                                                        <div className="icon">
                                                            <img src={btcGrayIcon} alt="icon" />
                                                        </div>
                                                        <div className="content">
                                                            <h3 className="h-font f-24 title">1.34 BTC</h3>
                                                            <h3 className="h-font f-20">$2838.3</h3>
                                                        </div>
                                                    </div>
                                                    <div className="your-asset-card">
                                                        <div className="icon">
                                                            <img src={btcGrayIcon} alt="icon" />
                                                        </div>
                                                        <div className="content">
                                                            <h3 className="h-font f-24 title">1.34 BTC</h3>
                                                            <h3 className="h-font f-20">$2838.3</h3>
                                                        </div>
                                                    </div>
                                                    <div className="your-asset-card">
                                                        <div className="icon">
                                                            <img src={btcGrayIcon} alt="icon" />
                                                        </div>
                                                        <div className="content">
                                                            <h3 className="h-font f-24 title">1.34 BTC</h3>
                                                            <h3 className="h-font f-20">$2838.3</h3>
                                                        </div>
                                                    </div>
                                                </Slider>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </section>
            {/* <section className="sec-wallet">
                <div className="container">
                    <div className="wallet-wrapper">
                        <div className="tabs-wrapper">
                            <Tab.Container defaultActiveKey="first">
                                <div className="tabs-header">
                                    <Nav variant="pills">
                                        <Nav.Item>
                                            <Nav.Link eventKey="first"><h3>Assets</h3></Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="second"><h3>Whitelist Wallet</h3></Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </div>
                                <div className="tabs-body">
                                    <Tab.Content>
                                        <Tab.Pane eventKey="first">
                                            <div className="asset-wrapper">
                                                <div className="asset-header">
                                                    <div className="row">
                                                        <div className="col-md-6 col-7 align-self-center">
                                                            <div className="search-wrapper-v1">
                                                                <div className="form">
                                                                    <div className="form-group">
                                                                        <input type="text" className="form-control" placeholder="Search" />
                                                                        <img src={searchIcon} className="icon" alt="icon" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 col-5 align-self-center">
                                                            <ul className="btn-list">
                                                                <li><a href="#" className="btn-style m-w-130 transparent">Show All Assets</a></li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="asset-body">
                                                    <div className="asset-list-wrapper">
                                                        <div className="asset-list desktop">
                                                            <div className="table-header grid-5">
                                                                <div className="asset-item">
                                                                    <p>Asset</p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p>Balance</p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p>Price <img src={arrowDownIcon} alt="icon" /></p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p>Portfolio %</p>
                                                                </div>
                                                                <div className="asset-item"></div>
                                                            </div>


                                                            <div className="asset-card grid-5">
                                                                <div className="asset-item">
                                                                    <div className="name-wrapper">
                                                                        <div className="icon">
                                                                            <img src={xdcLogo} alt="img" />
                                                                        </div>
                                                                        <div className="content">
                                                                            <p className="title p">XDC</p>
                                                                            <p>xdc</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p className="p w-600">0 BTC</p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p className="p w-600">0.00323 USD</p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p className="p w-600">12%</p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <ul className="btn-list">
                                                                        <li><a href="#" className="btn-style h-36 transparent" onClick={onAssetsWithdrawFundsShow}>Withdraw</a></li>
                                                                        <li><a href="#" className="btn-style h-36 transparent" onClick={onFiatDepositShow}>Deposit</a></li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                            <div className="asset-card grid-5">
                                                                <div className="asset-item">
                                                                    <div className="name-wrapper">
                                                                        <div className="icon">
                                                                            <img src={bitcoinImage} alt="img" />
                                                                        </div>
                                                                        <div className="content">
                                                                            <p className="title p">Bitcoin</p>
                                                                            <p>btc</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p className="p w-600">0 BTC</p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p className="p w-600">0.00323 USD</p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p className="p w-600">12%</p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <ul className="btn-list">
                                                                        <li><a href="#" className="btn-style h-36 transparent" onClick={onAssetsWithdrawShow}>Withdraw</a></li>
                                                                        <li><a href="#" className="btn-style h-36 transparent" onClick={onAssetsDepositWalletShow}>Deposit</a></li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                            <div className="asset-card grid-5">
                                                                <div className="asset-item">
                                                                    <div className="name-wrapper">
                                                                        <div className="icon">
                                                                            <img src={etheriumImage} alt="img" />
                                                                        </div>
                                                                        <div className="content">
                                                                            <p className="title p">Etherium</p>
                                                                            <p>eth</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p className="p w-600">0 BTC</p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p className="p w-600">0.00323 USD</p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p className="p w-600">12%</p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <ul className="btn-list">
                                                                        <li><a href="#" className="btn-style h-36 transparent" onClick={onAssetsWithdrawShow}>Withdraw</a></li>
                                                                        <li><a href="#" className="btn-style h-36 transparent" onClick={onAssetsDepositWalletShow}>Deposit</a></li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                            <div className="asset-card grid-5">
                                                                <div className="asset-item">
                                                                    <div className="name-wrapper">
                                                                        <div className="icon">
                                                                            <img src={usdLogo} alt="img" />
                                                                        </div>
                                                                        <div className="content">
                                                                            <p className="title p">USD</p>
                                                                            <p>usd</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p className="p w-600">0 BTC</p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p className="p w-600">0.00323 USD</p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p className="p w-600">12%</p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <ul className="btn-list">
                                                                        <li><a href="#" className="btn-style h-36 transparent" onClick={onAssetsWithdrawFundsShow}>Withdraw</a></li>
                                                                        <li><a href="#" className="btn-style h-36 transparent" onClick={onFiatDepositShow}>Deposit</a></li>
                                                                    </ul>
                                                                </div>
                                                            </div>


                                                        </div>
                                                        <div className="asset-list-mobile">
                                                            <div className="asset-list-card">
                                                                <ul className="asset-detail">
                                                                    <li>
                                                                        <div className="name-wrapper">
                                                                            <div className="icon">
                                                                                <img src={bitcoinImage} alt="img" />
                                                                            </div>
                                                                            <div className="content">
                                                                                <p className="title w-800">Bitcoin</p>
                                                                                <p className="f-12 w-600">BTC</p>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Portfolio %</p>
                                                                        <p className="p w-600">12%</p>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Price</p>
                                                                        <p className="p w-600">0.00323 USD</p>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Balance</p>
                                                                        <p className="p w-600">0 BTC</p>
                                                                    </li>
                                                                </ul>
                                                                <ul className="asset-btn">
                                                                    <li><a href="#" className="btn-style transparent" onClick={onAssetsWithdrawMobileShow}>Withdraw</a></li>
                                                                    <li><a href="#" className="btn-style transparent" onClick={onAssetsDepositWalletMobileShow}>Deposit</a></li>
                                                                </ul>
                                                            </div>
                                                            <div className="asset-list-card">
                                                                <ul className="asset-detail">
                                                                    <li>
                                                                        <div className="name-wrapper">
                                                                            <div className="icon">
                                                                                <img src={bitcoinImage} alt="img" />
                                                                            </div>
                                                                            <div className="content">
                                                                                <p className="title w-800">Bitcoin</p>
                                                                                <p className="f-12 w-600">BTC</p>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Portfolio %</p>
                                                                        <p className="p w-600">12%</p>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Price</p>
                                                                        <p className="p w-600">0.00323 USD</p>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Balance</p>
                                                                        <p className="p w-600">0 BTC</p>
                                                                    </li>
                                                                </ul>
                                                                <ul className="asset-btn">
                                                                    <li><a href="#" className="btn-style transparent">Withdraw</a></li>
                                                                    <li><a href="#" className="btn-style transparent">Deposit</a></li>
                                                                </ul>
                                                            </div>

                                                            <div className="asset-list-card">
                                                                <ul className="asset-detail">
                                                                    <li>
                                                                        <div className="name-wrapper">
                                                                            <div className="icon">
                                                                                <img src={bitcoinImage} alt="img" />
                                                                            </div>
                                                                            <div className="content">
                                                                                <p className="title w-800">Bitcoin</p>
                                                                                <p className="f-12 w-600">BTC</p>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Portfolio %</p>
                                                                        <p className="p w-600">12%</p>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Price</p>
                                                                        <p className="p w-600">0.00323 USD</p>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Balance</p>
                                                                        <p className="p w-600">0 BTC</p>
                                                                    </li>
                                                                </ul>
                                                                <ul className="asset-btn">
                                                                    <li><a href="#" className="btn-style transparent">Withdraw</a></li>
                                                                    <li><a href="#" className="btn-style transparent">Deposit</a></li>
                                                                </ul>
                                                            </div>
                                                            <div className="asset-list-card">
                                                                <ul className="asset-detail">
                                                                    <li>
                                                                        <div className="name-wrapper">
                                                                            <div className="icon">
                                                                                <img src={bitcoinImage} alt="img" />
                                                                            </div>
                                                                            <div className="content">
                                                                                <p className="title w-800">Bitcoin</p>
                                                                                <p className="f-12 w-600">BTC</p>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Portfolio %</p>
                                                                        <p className="p w-600">12%</p>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Price</p>
                                                                        <p className="p w-600">0.00323 USD</p>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Balance</p>
                                                                        <p className="p w-600">0 BTC</p>
                                                                    </li>
                                                                </ul>
                                                                <ul className="asset-btn">
                                                                    <li><a href="#" className="btn-style transparent">Withdraw</a></li>
                                                                    <li><a href="#" className="btn-style transparent">Deposit</a></li>
                                                                </ul>
                                                            </div>

                                                            <div className="asset-list-card">
                                                                <ul className="asset-detail">
                                                                    <li>
                                                                        <div className="name-wrapper">
                                                                            <div className="icon">
                                                                                <img src={bitcoinImage} alt="img" />
                                                                            </div>
                                                                            <div className="content">
                                                                                <p className="title w-800">Bitcoin</p>
                                                                                <p className="f-12 w-600">BTC</p>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Portfolio %</p>
                                                                        <p className="p w-600">12%</p>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Price</p>
                                                                        <p className="p w-600">0.00323 USD</p>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Balance</p>
                                                                        <p className="p w-600">0 BTC</p>
                                                                    </li>
                                                                </ul>
                                                                <ul className="asset-btn">
                                                                    <li><a href="#" className="btn-style transparent">Withdraw</a></li>
                                                                    <li><a href="#" className="btn-style transparent">Deposit</a></li>
                                                                </ul>
                                                            </div>
                                                            <div className="asset-list-card">
                                                                <ul className="asset-detail">
                                                                    <li>
                                                                        <div className="name-wrapper">
                                                                            <div className="icon">
                                                                                <img src={bitcoinImage} alt="img" />
                                                                            </div>
                                                                            <div className="content">
                                                                                <p className="title w-800">Bitcoin</p>
                                                                                <p className="f-12 w-600">BTC</p>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Portfolio %</p>
                                                                        <p className="p w-600">12%</p>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Price</p>
                                                                        <p className="p w-600">0.00323 USD</p>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Balance</p>
                                                                        <p className="p w-600">0 BTC</p>
                                                                    </li>
                                                                </ul>
                                                                <ul className="asset-btn">
                                                                    <li><a href="#" className="btn-style transparent">Withdraw</a></li>
                                                                    <li><a href="#" className="btn-style transparent">Deposit</a></li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="second">
                                            <div className="asset-wrapper">
                                                <div className="asset-header">
                                                    <div className="row">
                                                        <div className="col-md-6 col-7 align-self-center">
                                                            <div className="search-wrapper-v1">
                                                                <div className="form">
                                                                    <div className="form-group">
                                                                        <input type="text" className="form-control" placeholder="Search" />
                                                                        <img src={searchIcon} className="icon" alt="icon" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 col-5 align-self-center">
                                                            <ul className="btn-list">
                                                                <li><a href="#" className="btn-style m-w-130 transparent" onClick={onAddWhitelistWalletShow}>Add Whitelist Wallet</a></li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="asset-body">
                                                    <div className="asset-list-wrapper">
                                                        <div className="asset-list desktop">
                                                            <div className="table-header grid-4">
                                                                <div className="asset-item">
                                                                    <p>Wallet</p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p>Balance</p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p>Balance in USD <img src={arrowDownIcon} alt="icon" /></p>
                                                                </div>
                                                                <div className="asset-item"></div>
                                                            </div>
                                                            <div className="asset-card grid-4">
                                                                <div className="asset-item">
                                                                    <div className="name-wrapper">
                                                                        <div className="wallet-icon">
                                                                            <img src={walletDarkIcon} className="wallet-icon" alt="img" />
                                                                            <img src={btcTagIcon} className="tag-icon" alt="img" />
                                                                        </div>
                                                                        <div className="content">
                                                                            <p className="title p">John’s Test Wallet</p>
                                                                            <p>BTC</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p className="p w-600">0.00323 BTC</p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p className="p w-600">$2382.34 USD</p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <ul className="btn-list">
                                                                        <li><a href="#" className="btn-style h-36 transparent" onClick={onAssetsWithdrawShow}>Withdraw</a></li>
                                                                        <li><a href="#" className="btn-style h-36 transparent" onClick={onWalletsDepositWalletShow}>Deposit</a></li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                            <div className="asset-card grid-4">
                                                                <div className="asset-item">
                                                                    <div className="name-wrapper">
                                                                        <div className="wallet-icon">
                                                                            <img src={walletDarkIcon} className="wallet-icon" alt="img" />
                                                                            <img src={usdLogo} className="tag-icon" alt="img" />
                                                                        </div>
                                                                        <div className="content">
                                                                            <p className="title p">Raj Wallet</p>
                                                                            <p>USD</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p className="p w-600">0.00323 BTC</p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p className="p w-600">$2382.34 USD</p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <ul className="btn-list">
                                                                        <li><a href="#" className="btn-style h-36 transparent" onClick={onAssetsWithdrawFundsShow}>Withdraw</a></li>
                                                                        <li><a href="#" className="btn-style h-36 transparent" onClick={onAssetsWithdrawFundsShow}>Deposit</a></li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="asset-list-mobile">
                                                            <div className="asset-list-card">
                                                                <ul className="asset-detail">
                                                                    <li>
                                                                        <div className="name-wrapper">
                                                                            <div className="wallet-icon">
                                                                                <img src={walletDarkIcon} className="wallet-icon" alt="img" />
                                                                                <img src={btcTagIcon} className="tag-icon" alt="img" />
                                                                            </div>
                                                                            <div className="content">
                                                                                <p className="title">John’s Test Wallet</p>
                                                                                <p>BTC</p>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Portfolio %</p>
                                                                        <p className="p w-600">12%</p>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Price</p>
                                                                        <p className="p w-600">0.00323 USD</p>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Balance</p>
                                                                        <p className="p w-600">0 BTC</p>
                                                                    </li>
                                                                </ul>
                                                                <ul className="asset-btn">
                                                                    <li><a href="#" className="btn-style transparent">Withdraw</a></li>
                                                                    <li><a href="#" className="btn-style transparent" onClick={onWalletsDepositWalletMobileShow}>Deposit</a></li>
                                                                </ul>
                                                            </div>
                                                            <div className="asset-list-card">
                                                                <ul className="asset-detail">
                                                                    <li>
                                                                        <div className="name-wrapper">
                                                                            <div className="wallet-icon">
                                                                                <img src={walletDarkIcon} className="wallet-icon" alt="img" />
                                                                                <img src={btcTagIcon} className="tag-icon" alt="img" />
                                                                            </div>
                                                                            <div className="content">
                                                                                <p className="title">John’s Test Wallet</p>
                                                                                <p>BTC</p>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Portfolio %</p>
                                                                        <p className="p w-600">12%</p>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Price</p>
                                                                        <p className="p w-600">0.00323 USD</p>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Balance</p>
                                                                        <p className="p w-600">0 BTC</p>
                                                                    </li>
                                                                </ul>
                                                                <ul className="asset-btn">
                                                                    <li><a href="#" className="btn-style transparent">Withdraw</a></li>
                                                                    <li><a href="#" className="btn-style transparent">Deposit</a></li>
                                                                </ul>
                                                            </div>

                                                            <div className="asset-list-card">
                                                                <ul className="asset-detail">
                                                                    <li>
                                                                        <div className="name-wrapper">
                                                                            <div className="wallet-icon">
                                                                                <img src={walletDarkIcon} className="wallet-icon" alt="img" />
                                                                                <img src={btcTagIcon} className="tag-icon" alt="img" />
                                                                            </div>
                                                                            <div className="content">
                                                                                <p className="title">John’s Test Wallet</p>
                                                                                <p>BTC</p>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Portfolio %</p>
                                                                        <p className="p w-600">12%</p>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Price</p>
                                                                        <p className="p w-600">0.00323 USD</p>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Balance</p>
                                                                        <p className="p w-600">0 BTC</p>
                                                                    </li>
                                                                </ul>
                                                                <ul className="asset-btn">
                                                                    <li><a href="#" className="btn-style transparent">Withdraw</a></li>
                                                                    <li><a href="#" className="btn-style transparent">Deposit</a></li>
                                                                </ul>
                                                            </div>
                                                            <div className="asset-list-card">
                                                                <ul className="asset-detail">
                                                                    <li>
                                                                        <div className="name-wrapper">
                                                                            <div className="wallet-icon">
                                                                                <img src={walletDarkIcon} className="wallet-icon" alt="img" />
                                                                                <img src={btcTagIcon} className="tag-icon" alt="img" />
                                                                            </div>
                                                                            <div className="content">
                                                                                <p className="title">John’s Test Wallet</p>
                                                                                <p>BTC</p>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Portfolio %</p>
                                                                        <p className="p w-600">12%</p>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Price</p>
                                                                        <p className="p w-600">0.00323 USD</p>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Balance</p>
                                                                        <p className="p w-600">0 BTC</p>
                                                                    </li>
                                                                </ul>
                                                                <ul className="asset-btn">
                                                                    <li><a href="#" className="btn-style transparent">Withdraw</a></li>
                                                                    <li><a href="#" className="btn-style transparent">Deposit</a></li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Tab.Pane>
                                    </Tab.Content>
                                </div>
                            </Tab.Container>
                        </div>
                    </div>
                </div>
            </section> */}

            {/* Deposit Modal Start */}
            <Modal size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered className="modal deposit-wallet-modal" show={depositShow} onHide={onDepositClose}>
                <Modal.Body>
                    <div className="deposit-wallet-wrapper">
                        <div className="wallet-header">
                            <div className="row">
                                <div className="col-6 align-self-center">
                                    <h3 className="h3">Deposit</h3>
                                </div>
                                <div className="col-6 align-self-center">
                                    <div className="reset-wrapper">
                                        <a href="#" onClick={onDepositClose}><img src={crossIcon} alt="icon" /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-body">
                            <div className="deposit-wrapper">
                                <div className="deposit-item">
                                    <h3>Asset</h3>
                                    <CoinSelectDropdown
                                        options={selectCoinOptions}
                                        onSelect={onSelectCoin}
                                        placeholderIcon={walletIcon}
                                        className="coin-dropdown"
                                    />
                                </div>
                                <div className="deposit-item">
                                    <h3>Amount</h3>
                                    <div className="deposit-card">
                                        <div className="row">
                                            <div className="col-6 align-self-end align-self-md-center">
                                                <div className="amount-tabs">
                                                    <Tab.Container defaultActiveKey="first">
                                                        <div className="tabs-header">
                                                            <Nav variant="pills">
                                                                <Nav.Item>
                                                                    <Nav.Link eventKey="first"><p className="p w-600">USD</p></Nav.Link>
                                                                </Nav.Item>
                                                                <Nav.Item>
                                                                    <Nav.Link eventKey="second"><p className="p w-600">BTC</p></Nav.Link>
                                                                </Nav.Item>
                                                            </Nav>
                                                        </div>
                                                        <div className="tabs-body">
                                                            <Tab.Content>
                                                                <Tab.Pane eventKey="first">
                                                                    <div className="amount-input">
                                                                        <input type="text" placeholder="Enter Amount" />
                                                                    </div>
                                                                </Tab.Pane>
                                                                <Tab.Pane eventKey="second">
                                                                    <div className="amount-input">
                                                                        <input type="text" placeholder="Enter Amount" />
                                                                    </div>
                                                                </Tab.Pane>
                                                            </Tab.Content>
                                                        </div>
                                                    </Tab.Container>
                                                </div>
                                            </div>
                                            <div className="col-6 align-self-end align-self-md-center">
                                                <div className="amount-total">
                                                    <p className="p w-600">0 BTC = $0.00 USD</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="deposit-item">
                                    <h3>Deposit Into</h3>
                                    <SelectDropdown
                                        options={selectWalletOptions}
                                        onSelect={onSelectWallet}
                                        placeholder="Select a wallet"
                                        placeholderIcon={walletIcon}
                                        className="wallet-dropdown"
                                    /> */}
                                {/* <div className="deposit-card deposit-search-card">
                                        // Search Wrapper
                                    {!showQRCode && (
                                        <div className="search-wrapper-v1">
                                            <div className="form search-form">
                                                <div className="form-group">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search"
                                                        value={searchQuery}
                                                        onChange={(e) => setSearchQuery(e.target.value)}
                                                    />
                                                    <img src={searchIcon} className="icon" alt="icon" />
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    // No Wallet Wrapper
                                    {!showQRCode && filteredWallets.length === 0 && (
                                        <div className="no-wallet-wrapper">
                                            <div className="icon-wrapper">
                                                <img src={walletIcon} alt="icon" />
                                            </div>
                                            <h3 className="f-17">You don’t have any wallet</h3>
                                        </div>
                                    )}

                                    // User Wallet Wrapper 
                                    {!showQRCode && filteredWallets.length > 0 && (
                                        <div className="user-wallet-wrapper">
                                            {filteredWallets.map(wallet => (
                                                <div
                                                    key={wallet.id}
                                                    className="wallet-card"
                                                    onClick={() => setShowQRCode(true)}
                                                >
                                                    <div className="icon-wrapper">
                                                        <img src={walletIcon} alt="icon" />
                                                    </div>
                                                    <h3 className="f-17">{wallet.name}</h3>
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    // QR Code Wrapper 
                                    {showQRCode && (
                                        <div className="qrcode-wrapper">
                                            <div className="qr-img">
                                                <img src={qrcodeImage} alt="img" />
                                            </div>
                                            <div className="qr-content">
                                                <p className="p w-700">0x233434344......34343</p>
                                                <a
                                                    href="#"
                                                    className="btn-style transparent"
                                                    onClick={(e) => {
                                                        e.preventDefault(); // Prevent default anchor behavior
                                                        navigator.clipboard.writeText('0x233434344......34343')
                                                            .then(() => console.log('Address copied to clipboard!'))
                                                            .catch((err) => console.error('Failed to copy address:', err));
                                                    }}
                                                >
                                                    Copy Address to Clipboard
                                                </a>
                                            </div>
                                        </div>
                                    )}
                                </div> */}
                                {/* </div> */}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            {/* Deposit Modal End */}

            {/* Withdraw Modal Start */}
            <Modal size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered className="modal deposit-wallet-modal" show={withdrawShow} onHide={onWithdrawClose}>
                <Modal.Body>
                    <div className="deposit-wallet-wrapper">
                        <div className="wallet-header">
                            <div className="row">
                                <div className="col-6 align-self-center">
                                    <h3 className="h3">Withdraw</h3>
                                </div>
                                <div className="col-6 align-self-center">
                                    <div className="reset-wrapper">
                                        <a href="#" onClick={onWithdrawClose}><img src={crossIcon} alt="icon" /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-body">
                            <div className="deposit-wrapper">
                                <div className="deposit-item">
                                    <h3>Asset</h3>
                                    <CoinSelectDropdown
                                        options={selectCoinOptions}
                                        onSelect={onSelectCoin}
                                        placeholderIcon={walletIcon}
                                        className="coin-dropdown"
                                    />
                                </div>
                                <div className="deposit-item">
                                    <h3>From</h3>
                                    <CoinSelectDropdown
                                        options={selectWalletCoinOptions}
                                        onSelect={onSelectWalletCoin}
                                        placeholderIcon={walletIcon}
                                        className="wallet-dropdown"
                                    />
                                </div>
                                <div className="deposit-item">
                                    <h3>Send To</h3>
                                    <div className="send-to-tabs">
                                        <Tab.Container defaultActiveKey="first">
                                            <div className="tabs-header">
                                                <Nav variant="pills">
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="first"><p className="p w-600">Any Address</p></Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="second"><p className="p w-600">Wallet</p></Nav.Link>
                                                    </Nav.Item>
                                                </Nav>
                                            </div>
                                            <div className="tabs-body">
                                                <Tab.Content>
                                                    <Tab.Pane eventKey="first">
                                                        <div className="deposit-item">
                                                            <h3>Enter Address</h3>
                                                            <div className="form">
                                                                <div className="form-group">
                                                                    <input type="text" className="form-control" placeholder="Enter address here" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Tab.Pane>
                                                    <Tab.Pane eventKey="second">
                                                        <div className="deposit-item">
                                                            <h3>Select Wallet</h3>
                                                            <SelectDropdown
                                                                options={selectWalletOptions}
                                                                onSelect={onSelectWallet}
                                                                placeholder="Select a wallet"
                                                                placeholderIcon={walletIcon}
                                                                className="wallet-dropdown"
                                                            />
                                                        </div>
                                                    </Tab.Pane>
                                                </Tab.Content>
                                            </div>
                                        </Tab.Container>
                                    </div>
                                </div>
                                <div className="deposit-item">
                                    <h3>Amount</h3>
                                    <div className="deposit-card">
                                        <div className="row">
                                            <div className="col-6 align-self-end align-self-md-center">
                                                <div className="amount-tabs">
                                                    <Tab.Container defaultActiveKey="first">
                                                        <div className="tabs-header">
                                                            <Nav variant="pills">
                                                                <Nav.Item>
                                                                    <Nav.Link eventKey="first"><p className="p w-600">USD</p></Nav.Link>
                                                                </Nav.Item>
                                                                <Nav.Item>
                                                                    <Nav.Link eventKey="second"><p className="p w-600">BTC</p></Nav.Link>
                                                                </Nav.Item>
                                                            </Nav>
                                                        </div>
                                                        <div className="tabs-body">
                                                            <Tab.Content>
                                                                <Tab.Pane eventKey="first">
                                                                    <div className="amount-input">
                                                                        <input type="text" placeholder="Enter Amount" />
                                                                    </div>
                                                                </Tab.Pane>
                                                                <Tab.Pane eventKey="second">
                                                                    <div className="amount-input">
                                                                        <input type="text" placeholder="Enter Amount" />
                                                                    </div>
                                                                </Tab.Pane>
                                                            </Tab.Content>
                                                        </div>
                                                    </Tab.Container>
                                                </div>
                                            </div>
                                            <div className="col-6 align-self-end align-self-md-center">
                                                <div className="amount-total">
                                                    <p className="p w-600">0 BTC = $0.00 USD</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-footer">
                            <ul className="btn-list">
                                <li><a href="#" className="btn-style">Confirm</a></li>
                            </ul>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            {/* Withdraw Modal End */}


            {/* Assets Deposit Wallet Modal Start */}
            <Modal size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered className="modal deposit-select-wallet-modal" show={assetsDepositWalletShow} onHide={onAssetsDepositWalletClose}>
                <Modal.Body>
                    <div className="deposit-wallet-wrapper">
                        <div className="wallet-header">
                            <div className="row">
                                <div className="col-6 align-self-center">
                                    <h3 className="h3">Deposit</h3>
                                </div>
                                <div className="col-6 align-self-center">
                                    {/*<div className="reset-wrapper">
                                        <a href="#" onClick={onAssetsDepositWalletClose}><img src={crossIcon} alt="icon"/></a>
                                    </div>*/}
                                    <div className="selected-coin">
                                        <div className="icon">
                                            <img src={usdcIcon} alt="icon" />
                                            <p className="p w-700">USDC</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-body">
                            <div className="deposit-wrapper">
                                <div className="deposit-item">
                                    <SelectDropdown
                                        options={selectWalletOptions}
                                        onSelect={onSelectWallet}
                                        placeholder="Select a wallet"
                                        placeholderIcon={walletIcon}
                                        className="wallet-dropdown"
                                    />
                                </div>
                                <div className="deposit-item">
                                    <h3>Address</h3>
                                    <div className="deposit-card">
                                        <div className="qrcode-wrapper">
                                            <div className="qr-img">
                                                <img src={qrcodeImage} alt="img" />
                                            </div>
                                            <div className="qr-content">
                                                <p className="p w-700">0x233434344......34343</p>
                                                <a
                                                    href="#"
                                                    className="btn-style transparent"
                                                    onClick={(e) => {
                                                        e.preventDefault(); // Prevent default anchor behavior
                                                        navigator.clipboard.writeText('0x233434344......34343')
                                                            .then(() => console.log('Address copied to clipboard!'))
                                                            .catch((err) => console.error('Failed to copy address:', err));
                                                    }}
                                                >
                                                    Copy Address to Clipboard
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            {/* Assets Deposit Wallet Modal End */}

            {/* Wallets Deposit Wallet Modal Start */}
            <Modal size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered className="modal deposit-select-wallet-modal" show={walletsDepositWalletShow} onHide={onWalletsDepositWalletClose}>
                <Modal.Body>
                    <div className="deposit-wallet-wrapper">
                        <div className="wallet-header">
                            <div className="row">
                                <div className="col-6 align-self-center">
                                    <h3 className="h3">Deposit</h3>
                                </div>
                                <div className="col-6 align-self-center">
                                    {/*<div className="reset-wrapper">
                                        <a href="#" onClick={onAssetsDepositWalletClose}><img src={crossIcon} alt="icon"/></a>
                                    </div>*/}
                                    <div className="selected-coin">
                                        <div className="icon">
                                            <img src={bitcoinImage} alt="icon" />
                                            <p className="p w-700">BTC</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-body">
                            <div className="deposit-wrapper">
                                <div className="deposit-item">
                                    <div className="item-header">
                                        <div className="row">
                                            <div className="col-md-4 align-self-center">
                                                <h3>Address</h3>
                                            </div>
                                            <div className="col-md-8 align-self-center">
                                                <p className="p w-600">John’s Test BTC Wallet</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="deposit-card">
                                        <div className="qrcode-wrapper">
                                            <div className="qr-img">
                                                <img src={qrcodeImage} alt="img" />
                                            </div>
                                            <div className="qr-content">
                                                <p className="p w-700">0x233434344......34343</p>
                                                {/*<a
                                                    href="#"
                                                    className="btn-style transparent"
                                                    onClick={(e) => {
                                                        e.preventDefault(); // Prevent default anchor behavior
                                                        navigator.clipboard.writeText('0x233434344......34343')
                                                            .then(() => console.log('Address copied to clipboard!'))
                                                            .catch((err) => console.error('Failed to copy address:', err));
                                                    }}
                                                >
                                                    Copy Address to Clipboard
                                                </a>*/}
                                                <a
                                                    href="#"
                                                    className="btn-style transparent"
                                                    onClick={onFiatDepositShow}
                                                >
                                                    Copy Address to Clipboard
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            {/* Wallets Deposit Wallet Modal End */}


            {/* Fiat Deposit Modal Start */}
            {/* <Modal size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered className="modal deposit-select-wallet-modal fiat-deposit-modal" show={fiatDepositShow} onHide={onFiatDepositClose}>
                <Modal.Body>
                    <div className="deposit-wallet-wrapper">
                        <div className="wallet-header">
                            <div className="row">
                                <div className="col-6 align-self-center">
                                    <h3 className="h3">Deposit</h3>
                                </div>
                                <div className="col-6 align-self-center">
                                    <div className="reset-wrapper">
                                        <a href="#" onClick={onAssetsDepositWalletClose}><img src={crossIcon} alt="icon" /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-body">
                            <div className="account-detail-main">
                                <h3 className="f-18">Account Details</h3>
                                <div className="account-detail-wrapper">
                                    <div className="account-card">
                                        <div className="bank-name">
                                            <div className="icon">
                                                <img src={bankIcon} alt="icon" />
                                            </div>
                                            <p className="f-12 w-700">Bank of America</p>
                                        </div>
                                        <ul className="account-detail-list">
                                            <li>
                                                <p className="f-10 w-600 title">Account No</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">SWIFT Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">MICR Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">Branch Address</p>
                                                <p className="f-12 w-600">Charlotte, North Carolina, United States</p>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="account-card">
                                        <div className="bank-name">
                                            <div className="icon">
                                                <img src={bankIcon} alt="icon" />
                                            </div>
                                            <p className="f-12 w-700">Bank of America</p>
                                        </div>
                                        <ul className="account-detail-list">
                                            <li>
                                                <p className="f-10 w-600 title">Account No</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">SWIFT Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">MICR Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">Branch Address</p>
                                                <p className="f-12 w-600">Charlotte, North Carolina, United States</p>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="account-card">
                                        <div className="bank-name">
                                            <div className="icon">
                                                <img src={bankIcon} alt="icon" />
                                            </div>
                                            <p className="f-12 w-700">Bank of America</p>
                                        </div>
                                        <ul className="account-detail-list">
                                            <li>
                                                <p className="f-10 w-600 title">Account No</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">SWIFT Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">MICR Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">Branch Address</p>
                                                <p className="f-12 w-600">Charlotte, North Carolina, United States</p>
                                            </li>
                                        </ul>
                                    </div>

                                    <div className="account-card">
                                        <div className="bank-name">
                                            <div className="icon">
                                                <img src={bankIcon} alt="icon" />
                                            </div>
                                            <p className="f-12 w-700">Bank of America</p>
                                        </div>
                                        <ul className="account-detail-list">
                                            <li>
                                                <p className="f-10 w-600 title">Account No</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">SWIFT Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">MICR Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">Branch Address</p>
                                                <p className="f-12 w-600">Charlotte, North Carolina, United States</p>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="account-card">
                                        <div className="bank-name">
                                            <div className="icon">
                                                <img src={bankIcon} alt="icon" />
                                            </div>
                                            <p className="f-12 w-700">Bank of America</p>
                                        </div>
                                        <ul className="account-detail-list">
                                            <li>
                                                <p className="f-10 w-600 title">Account No</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">SWIFT Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">MICR Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">Branch Address</p>
                                                <p className="f-12 w-600">Charlotte, North Carolina, United States</p>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="account-card">
                                        <div className="bank-name">
                                            <div className="icon">
                                                <img src={bankIcon} alt="icon" />
                                            </div>
                                            <p className="f-12 w-700">Bank of America</p>
                                        </div>
                                        <ul className="account-detail-list">
                                            <li>
                                                <p className="f-10 w-600 title">Account No</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">SWIFT Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">MICR Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">Branch Address</p>
                                                <p className="f-12 w-600">Charlotte, North Carolina, United States</p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="upload-wrapper">
                                <div className="row">
                                    <div className="col-md-8 align-self-center">
                                        <p className="f-15 w-600">Transferred the amount? Upload proof to confirm deposit</p>
                                    </div>
                                    <div className="col-md-4 align-self-center">
                                        <ul className="btn-list">
                                            <li><a href="#" className="btn-style transparent" onClick={onUploadProofShow}>Upload Proof</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal> */}
            {/* Fiat Deposit Modal End */}


            {/* Upload Proof Modal Start */}
            {/* <Modal size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered className="modal deposit-select-wallet-modal fiat-deposit-modal" show={uploadProofShow} onHide={onUploadProofClose}>
                <Modal.Body>
                    <div className="deposit-wallet-wrapper">
                        <div className="wallet-header">
                            <div className="row">
                                <div className="col-6 align-self-center">
                                    <h3 className="h3">Deposit</h3>
                                </div>
                                <div className="col-6 align-self-center">
                                    <div className="reset-wrapper">
                                        <a href="#" onClick={onAssetsDepositWalletClose}><img src={crossIcon} alt="icon" /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-body">
                            <div className="deposit-wrapper">
                                <div className="deposit-item">
                                    <h3>Enter Amount Deposited</h3>
                                    <div className="form">
                                        <div className="form-group">
                                            <input type="text" className="form-control" placeholder="Enter amount" />
                                        </div>
                                    </div>
                                </div>
                                <div className="deposit-item">
                                    <h3>Enter Account Details</h3>
                                    <div className="form">
                                        <div className="form-group">
                                            <input type="text" className="form-control" placeholder="Enter account number" />
                                        </div>
                                    </div>
                                </div>
                                <div className="deposit-item">
                                    <h3>Upload transfer receipts </h3>
                                    <div className="form">
                                        <div className="form-group">
                                            <div className="upload-card">
                                                <label htmlFor="upload-gallery-video" className="upload-label">
                                                    <div className="upload-gallery-wrapper">
                                                        <div className="upload-content">
                                                            <img src={uploadFileIcon} className="upload-icon" alt="Upload Icon" />
                                                            <p className="f-13 w-600">Drag or Drop Files Here</p>
                                                            <p className="f-13 w-600 or">or</p>
                                                            <a href="#" className="btn-style transparent">Upload Files</a>
                                                        </div>
                                                    </div>
                                                </label>
                                                <input type="file" id="upload-gallery-video" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="upload-wrapper">
                                    <ul className="btn-list">
                                        <li><a href="#" className="btn-style transparent">Submit</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal> */}
            {/* Upload Proof Modal End */}


            {/* Assets Withdraw Modal Start */}
            {/* <Modal size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered className="modal deposit-select-wallet-modal assets-withdraw-modal" show={assetsWithdrawShow} onHide={onAssetsWithdrawClose}>
                <Modal.Body>
                    <div className="deposit-wallet-wrapper">
                        <div className="wallet-header">
                            <div className="row">
                                <div className="col-6 align-self-center">
                                    <h3 className="h3">Withdraw</h3>
                                </div>
                                <div className="col-6 align-self-center">
                                    <div className="reset-wrapper">
                                        <a href="#" onClick={onWithdrawClose}><img src={crossIcon} alt="icon" /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-body">
                            <div className="deposit-wrapper">
                                <div className="deposit-item">
                                    <h3>Asset</h3>
                                    <CoinSelectDropdown
                                        options={selectCoinOptions}
                                        onSelect={onSelectCoin}
                                        placeholderIcon={walletIcon}
                                        className="coin-dropdown"
                                    />
                                </div>
                                <div className="deposit-item">
                                    <div className="item-header">
                                        <div className="row">
                                            <div className="col-3">
                                                <h3>From</h3>
                                            </div>
                                            <div className="col-9">
                                                <p className="p w-600">Address : 0x2344383848489399c8388484</p>
                                            </div>
                                        </div>
                                    </div>
                                    <SelectDropdown
                                        options={selectWalletOptions}
                                        onSelect={onSelectWallet}
                                        placeholder="Select a wallet"
                                        placeholderIcon={walletIcon}
                                        className="wallet-dropdown"
                                        showSpecificItem={1} // This will pre-select specific Wallet by passing index
                                    />
                                </div>
                                <div className="deposit-item">
                                    <h3>Enter Address</h3>
                                    <div className="form">
                                        <div className="form-group">
                                            <input type="text" className="form-control" placeholder="Enter address here" />
                                        </div>
                                    </div>
                                </div>
                                <div className="deposit-item">
                                    <div className="item-header">
                                        <div className="row">
                                            <div className="col-3">
                                                <h3>Amount</h3>
                                            </div>
                                            <div className="col-9">
                                                <p className="p w-600">Available Balance : 2.03 BTC</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form">
                                        <div className="form-group">
                                            <input type="text" className="form-control" placeholder="Enter BTC" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-footer">
                            <ul className="btn-list">
                                <li><a href="#" className="btn-style" onClick={onAssetsWithdrawFundsShow}>Confirm</a></li>
                            </ul>
                        </div>
                    </div>
                </Modal.Body>
            </Modal> */}
            {/* Assets Withdraw Modal End */}


            {/* Assets Withdraw Funds Modal Start */}
            {/* <Modal size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered className="modal deposit-select-wallet-modal assets-withdraw-funds-modal" show={assetsWithdrawFundsShow} onHide={onAssetsWithdrawFundsClose}>
                <Modal.Body>
                    <div className="deposit-wallet-wrapper">
                        <div className="wallet-header">
                            <div className="row">
                                <div className="col-4 align-self-center">
                                    <h3 className="h3">Withdraw</h3>
                                </div>
                                <div className="col-8 align-self-center">
                                    <div className="available-funds">
                                        <h3 className="f-20">Available Funds : $39293</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-body">
                            <div className="deposit-wrapper">
                                <div className="deposit-item">
                                    <h3>Choose a bank to withdraw money into</h3>
                                    <SelectDropdown
                                        options={selectBanksOptions}
                                        onSelect={onSelectBanks}
                                        placeholder="Select a bank"
                                        placeholderIcon={bankIcon}
                                        className="wallet-dropdown"
                                        showSpecificItem={2} // This will pre-select specific Wallet by passing index
                                    />
                                </div>
                                <div className="deposit-item">
                                    <h3>Amount</h3>
                                    <div className="form">
                                        <div className="form-group">
                                            <div className="amount-wrapper">
                                                <div className="icon"><p className="p w-600">$</p></div>
                                                <input type="text" className="form-control black-placeholder" placeholder="Enter Amount in USD" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-footer">
                            <ul className="btn-list">
                                <li><a href="#" className="btn-style">Submit</a></li>
                            </ul>
                        </div>
                    </div>
                </Modal.Body>
            </Modal> */}
            {/* Assets Withdraw Funds Modal End */}

            {/* Add Whitelist Wallet Modal Start */}
            <Modal size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered className="modal deposit-select-wallet-modal assets-withdraw-modal" show={addWhitelistWalletShow} onHide={onAddWhitelistWalletClose}>
                <Modal.Body>
                    <div className="deposit-wallet-wrapper">
                        <div className="wallet-header">
                            <div className="row">
                                <div className="col-6 align-self-center">
                                    <h3 className="h3">Add Whitelist Wallet</h3>
                                </div>
                                <div className="col-6 align-self-center">
                                    <div className="reset-wrapper">
                                        <a href="#" onClick={onWithdrawClose}><img src={crossIcon} alt="icon" /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-body">
                            <div className="deposit-wrapper">
                                <div className="deposit-item">
                                    <h3>Asset</h3>
                                    <CoinSelectDropdown
                                        options={selectAddWhitelistWalletOptions}
                                        onSelect={onSelectAddWhitelistWallet}
                                        placeholderIcon={walletIcon}
                                        className="coin-dropdown"
                                    />
                                </div>

                                {(whitelistCoinSelect == 'crypto') &&
                                    <div>
                                        <div className="deposit-item">
                                            <h3>Enter Address</h3>
                                            <div className="form">
                                                <div className="form-group">
                                                    <input type="text" className="form-control" placeholder="Enter address here" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="deposit-item">
                                            <div className="item-header">
                                                <h3>Enter OTP</h3>
                                            </div>
                                            <div className="form">
                                                <div className="form-group">
                                                    <input
                                                        type="text"
                                                        id="email-otp"
                                                        className="form-control otp-input"
                                                        placeholder="----"
                                                        value={otp}
                                                        onChange={handleOtpChange}
                                                        onPaste={handleOtpPaste}
                                                        maxLength="4" // Optional for better UX
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {(whitelistCoinSelect == 'crypto') &&
                                    <div>
                                        <div className="deposit-item">
                                            <h3>Bank Name</h3>
                                            <div className="form">
                                                <div className="form-group">
                                                    <input type="text" className="form-control" placeholder="Enter bank name" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="deposit-item">
                                            <h3>Account Number</h3>
                                            <div className="form">
                                                <div className="form-group">
                                                    <input type="text" className="form-control" placeholder="Enter account number" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="deposit-item">
                                            <h3>IBAN Code</h3>
                                            <div className="form">
                                                <div className="form-group">
                                                    <input type="text" className="form-control" placeholder="Enter IBAN code" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="deposit-item">
                                            <h3>Swift Code</h3>
                                            <div className="form">
                                                <div className="form-group">
                                                    <input type="text" className="form-control" placeholder="Enter swift code" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="deposit-item">
                                            <h3>Enter</h3>
                                            <div className="deposit-card">
                                                <div className="row">
                                                    <div className="col-6 align-self-end align-self-md-center">
                                                        <div className="amount-tabs">
                                                            <Tab.Container defaultActiveKey="first">
                                                                <div className="tabs-header">
                                                                    <Nav variant="pills">
                                                                        <Nav.Item>
                                                                            <Nav.Link eventKey="first"><p className="p w-600">USD</p></Nav.Link>
                                                                        </Nav.Item>
                                                                        <Nav.Item>
                                                                            <Nav.Link eventKey="second"><p className="p w-600">EURO</p></Nav.Link>
                                                                        </Nav.Item>
                                                                    </Nav>
                                                                </div>
                                                                <div className="tabs-body">
                                                                    <Tab.Content>
                                                                        <Tab.Pane eventKey="first">
                                                                            <div className="amount-input">
                                                                                <input type="text" placeholder="Enter Amount" />
                                                                            </div>
                                                                        </Tab.Pane>
                                                                        <Tab.Pane eventKey="second">
                                                                            <div className="amount-input">
                                                                                <input type="text" placeholder="Enter Amount" />
                                                                            </div>
                                                                        </Tab.Pane>
                                                                    </Tab.Content>
                                                                </div>
                                                            </Tab.Container>
                                                        </div>
                                                    </div>
                                                    <div className="col-6 align-self-end align-self-md-center">
                                                        <div className="amount-total">
                                                            <p className="p w-600">0 EURO = $0.00 USD</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="deposit-item">
                                            <h3>Country</h3>
                                            <div className="form">
                                                <div className="form-group">
                                                    <input type="text" className="form-control" placeholder="Enter your country" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="wallet-footer">
                            <ul className="btn-list">
                                <li><a href="#" className="btn-style" onClick={onAssetsWithdrawFundsShow}>Confirm</a></li>
                            </ul>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            {/* Add Whitelist Wallet Modal End */}



            {/* Mobile Popups Start */}




            {/* Wallets Deposit Wallet Modal Start */}
            <Offcanvas show={walletsDepositWalletMobileShow} className="deposit-select-wallet-modal h-468" onHide={onWalletsDepositWalletMobileClose} placement={'bottom'}>
                <Offcanvas.Header closeButton>
                    {/*<Offcanvas.Title>Offcanvas</Offcanvas.Title>*/}
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="deposit-wallet-wrapper">
                        <div className="wallet-header">
                            <div className="row">
                                <div className="col-6 align-self-center">
                                    <h3 className="h3">Deposit</h3>
                                </div>
                                <div className="col-6 align-self-center">
                                    {/*<div className="reset-wrapper">
                                        <a href="#" onClick={onAssetsDepositWalletClose}><img src={crossIcon} alt="icon"/></a>
                                    </div>*/}
                                    <div className="selected-coin">
                                        <div className="icon">
                                            <img src={bitcoinImage} alt="icon" />
                                            <p className="p w-700">BTC</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-body">
                            <div className="deposit-wrapper">
                                <div className="deposit-item">
                                    <div className="item-header">
                                        <div className="row">
                                            <div className="col-4 align-self-center">
                                                <h3>Address</h3>
                                            </div>
                                            <div className="col-8 align-self-center">
                                                <p className="p w-600">John’s Test BTC Wallet</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="deposit-card">
                                        <div className="qrcode-wrapper">
                                            <div className="qr-img">
                                                <img src={qrcodeImage} alt="img" />
                                            </div>
                                            <div className="qr-content">
                                                <p className="p w-700">0x233434344......34343</p>
                                                {/*<a
                                                    href="#"
                                                    className="btn-style transparent"
                                                    onClick={(e) => {
                                                        e.preventDefault(); // Prevent default anchor behavior
                                                        navigator.clipboard.writeText('0x233434344......34343')
                                                            .then(() => console.log('Address copied to clipboard!'))
                                                            .catch((err) => console.error('Failed to copy address:', err));
                                                    }}
                                                >
                                                    Copy Address to Clipboard
                                                </a>*/}
                                                <a
                                                    href="#"
                                                    className="btn-style transparent"
                                                    onClick={onFiatDepositMobileShow}
                                                >
                                                    Copy Address to Clipboard
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
            {/* Wallets Deposit Wallet Modal End */}


            {/* Fiat Deposit Modal Start */}
            <Offcanvas show={fiatDepositMobileShow} className="deposit-select-wallet-modal h-635" onHide={onFiatDepositMobileClose} placement={'bottom'}>
                <Offcanvas.Header closeButton>
                    {/*<Offcanvas.Title>Offcanvas</Offcanvas.Title>*/}
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="deposit-wallet-wrapper">
                        <div className="wallet-header">
                            <div className="row">
                                <div className="col-6 align-self-center">
                                    <h3 className="h3">Deposit</h3>
                                </div>
                                <div className="col-6 align-self-center">
                                    {/*<div className="reset-wrapper">
                                        <a href="#" onClick={onAssetsDepositWalletClose}><img src={crossIcon} alt="icon"/></a>
                                    </div>*/}
                                </div>
                            </div>
                        </div>
                        <div className="wallet-body">
                            <div className="account-detail-main">
                                <h3 className="f-18">Account Details</h3>
                                <div className="account-detail-wrapper">
                                    <div className="account-card">
                                        <div className="bank-name">
                                            <div className="icon">
                                                <img src={bankIcon} alt="icon" />
                                            </div>
                                            <p className="f-12 w-700">Bank of America</p>
                                        </div>
                                        <ul className="account-detail-list">
                                            <li>
                                                <p className="f-10 w-600 title">Account No</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">SWIFT Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">MICR Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">Branch Address</p>
                                                <p className="f-12 w-600">Charlotte, North Carolina, United States</p>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="account-card">
                                        <div className="bank-name">
                                            <div className="icon">
                                                <img src={bankIcon} alt="icon" />
                                            </div>
                                            <p className="f-12 w-700">Bank of America</p>
                                        </div>
                                        <ul className="account-detail-list">
                                            <li>
                                                <p className="f-10 w-600 title">Account No</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">SWIFT Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">MICR Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">Branch Address</p>
                                                <p className="f-12 w-600">Charlotte, North Carolina, United States</p>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="account-card">
                                        <div className="bank-name">
                                            <div className="icon">
                                                <img src={bankIcon} alt="icon" />
                                            </div>
                                            <p className="f-12 w-700">Bank of America</p>
                                        </div>
                                        <ul className="account-detail-list">
                                            <li>
                                                <p className="f-10 w-600 title">Account No</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">SWIFT Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">MICR Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">Branch Address</p>
                                                <p className="f-12 w-600">Charlotte, North Carolina, United States</p>
                                            </li>
                                        </ul>
                                    </div>

                                    <div className="account-card">
                                        <div className="bank-name">
                                            <div className="icon">
                                                <img src={bankIcon} alt="icon" />
                                            </div>
                                            <p className="f-12 w-700">Bank of America</p>
                                        </div>
                                        <ul className="account-detail-list">
                                            <li>
                                                <p className="f-10 w-600 title">Account No</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">SWIFT Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">MICR Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">Branch Address</p>
                                                <p className="f-12 w-600">Charlotte, North Carolina, United States</p>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="account-card">
                                        <div className="bank-name">
                                            <div className="icon">
                                                <img src={bankIcon} alt="icon" />
                                            </div>
                                            <p className="f-12 w-700">Bank of America</p>
                                        </div>
                                        <ul className="account-detail-list">
                                            <li>
                                                <p className="f-10 w-600 title">Account No</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">SWIFT Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">MICR Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">Branch Address</p>
                                                <p className="f-12 w-600">Charlotte, North Carolina, United States</p>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="account-card">
                                        <div className="bank-name">
                                            <div className="icon">
                                                <img src={bankIcon} alt="icon" />
                                            </div>
                                            <p className="f-12 w-700">Bank of America</p>
                                        </div>
                                        <ul className="account-detail-list">
                                            <li>
                                                <p className="f-10 w-600 title">Account No</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">SWIFT Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">MICR Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">Branch Address</p>
                                                <p className="f-12 w-600">Charlotte, North Carolina, United States</p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="upload-wrapper">
                                <div className="row">
                                    <div className="col-md-8 align-self-center">
                                        <p className="f-15 w-600">Transferred the amount? <br className="mobile" /> Upload proof to confirm deposit</p>
                                    </div>
                                    <div className="col-md-4 align-self-center">
                                        <ul className="btn-list">
                                            <li><a href="#" className="btn-style transparent" onClick={onUploadProofMobileShow}>Upload Proof</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
            {/* Fiat Deposit Modal End */}

            {/* Upload Proof Modal Start */}
            <Offcanvas show={uploadProofMobileShow} className="deposit-select-wallet-modal h-610" onHide={onUploadProofMobileClose} placement={'bottom'}>
                <Offcanvas.Header closeButton>
                    {/*<Offcanvas.Title>Offcanvas</Offcanvas.Title>*/}
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="deposit-wallet-wrapper">
                        <div className="wallet-header">
                            <div className="row">
                                <div className="col-6 align-self-center">
                                    <h3 className="h3">Deposit</h3>
                                </div>
                                <div className="col-6 align-self-center">
                                    {/*<div className="reset-wrapper">
                                        <a href="#" onClick={onAssetsDepositWalletClose}><img src={crossIcon} alt="icon"/></a>
                                    </div>*/}
                                </div>
                            </div>
                        </div>
                        <div className="wallet-body">
                            <div className="deposit-wrapper">
                                <div className="deposit-item">
                                    <h3>Enter Amount Deposited</h3>
                                    <div className="form">
                                        <div className="form-group">
                                            <input type="text" className="form-control" placeholder="Enter amount" />
                                        </div>
                                    </div>
                                </div>
                                <div className="deposit-item">
                                    <h3>Enter Account Details</h3>
                                    <div className="form">
                                        <div className="form-group">
                                            <input type="text" className="form-control" placeholder="Enter account number" />
                                        </div>
                                    </div>
                                </div>
                                <div className="deposit-item">
                                    <h3>Upload transfer receipts </h3>
                                    <div className="form">
                                        <div className="form-group">
                                            <div className="upload-card">
                                                <label htmlFor="upload-gallery-video" className="upload-label">
                                                    <div className="upload-gallery-wrapper">
                                                        <div className="upload-content">
                                                            <img src={uploadFileIcon} className="upload-icon" alt="Upload Icon" />
                                                            <p className="f-13 w-600">Drag or Drop Files Here</p>
                                                            <p className="f-13 w-600 or">or</p>
                                                            <a href="#" className="btn-style transparent">Upload Files</a>
                                                        </div>
                                                    </div>
                                                </label>
                                                <input type="file" id="upload-gallery-video" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="upload-wrapper">
                                    <ul className="btn-list">
                                        <li><a href="#" className="btn-style transparent" onClick={onUploadProofMobileClose}>Submit</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
            {/* Upload Proof Modal End */}

            {/* Assets Deposit Wallet Modal Start */}
            <Offcanvas show={assetsDepositWalletMobileShow} className="deposit-select-wallet-modal h-566" onHide={onAssetsDepositWalletMobileClose} placement={'bottom'}>
                <Offcanvas.Header closeButton>
                    {/*<Offcanvas.Title>Offcanvas</Offcanvas.Title>*/}
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="deposit-wallet-wrapper">
                        <div className="wallet-header">
                            <div className="row">
                                <div className="col-6 align-self-center">
                                    <h3 className="h3">Deposit</h3>
                                </div>
                                <div className="col-6 align-self-center">
                                    {/*<div className="reset-wrapper">
                                        <a href="#" onClick={onAssetsDepositWalletClose}><img src={crossIcon} alt="icon"/></a>
                                    </div>*/}
                                    <div className="selected-coin">
                                        <div className="icon">
                                            <img src={usdcIcon} alt="icon" />
                                            <p className="p w-700">USDC</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-body">
                            <div className="deposit-wrapper">
                                <div className="deposit-item">
                                    <SelectDropdown
                                        options={selectWalletOptions}
                                        onSelect={onSelectWallet}
                                        placeholder="Select a wallet"
                                        placeholderIcon={walletIcon}
                                        className="wallet-dropdown"
                                    />
                                </div>
                                <div className="deposit-item">
                                    <h3>Address</h3>
                                    <div className="deposit-card">
                                        <div className="qrcode-wrapper">
                                            <div className="qr-img">
                                                <img src={qrcodeImage} alt="img" />
                                            </div>
                                            <div className="qr-content">
                                                <p className="p w-700">0x233434344......34343</p>
                                                <a
                                                    href="#"
                                                    className="btn-style transparent"
                                                    onClick={(e) => {
                                                        e.preventDefault(); // Prevent default anchor behavior
                                                        navigator.clipboard.writeText('0x233434344......34343')
                                                            .then(() => console.log('Address copied to clipboard!'))
                                                            .catch((err) => console.error('Failed to copy address:', err));
                                                    }}
                                                >
                                                    Copy Address to Clipboard
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
            {/* Assets Deposit Wallet Modal End */}

            {/* Assets Withdraw Modal Start */}
            {/* <Offcanvas show={assetsWithdrawMobileShow} className="deposit-select-wallet-modal h-644" onHide={onAssetsWithdrawMobileClose} placement={'bottom'}>
                <Offcanvas.Header closeButton>
                   //<Offcanvas.Title>Offcanvas</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="deposit-wallet-wrapper">
                        <div className="wallet-header">
                            <div className="row">
                                <div className="col-6 align-self-center">
                                    <h3 className="h3">Withdraw</h3>
                                </div>
                                <div className="col-6 align-self-center">
                                    <div className="reset-wrapper">
                                        //<a href="#" onClick={onWithdrawClose}><img src={crossIcon} alt="icon"/></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-body">
                            <div className="deposit-wrapper">
                                <div className="deposit-item">
                                    <h3>Asset</h3>
                                    <CoinSelectDropdown
                                        options={selectCoinOptions}
                                        onSelect={onSelectCoin}
                                        placeholderIcon={walletIcon}
                                        className="coin-dropdown"
                                    />
                                </div>
                                <div className="deposit-item">
                                    <div className="item-header">
                                        <div className="row">
                                            <div className="col-3">
                                                <h3>From</h3>
                                            </div>
                                            <div className="col-9">
                                                //<p className="p w-600">Address : 0x2344383848489399c8388484</p>
                                            </div>
                                        </div>
                                    </div>
                                    <SelectDropdown
                                        options={selectWalletOptions}
                                        onSelect={onSelectWallet}
                                        placeholder="Select a wallet"
                                        placeholderIcon={walletIcon}
                                        className="wallet-dropdown"
                                        showSpecificItem={1} // This will pre-select specific Wallet by passing index
                                    />
                                    <p className="p w-600 wallet-address-text">Address : 0x2344383848489399c8388484</p>
                                </div>
                                <div className="deposit-item">
                                    <h3>Enter Address</h3>
                                    <div className="form">
                                        <div className="form-group">
                                            <input type="text" className="form-control" placeholder="Enter address here" />
                                        </div>
                                    </div>
                                </div>
                                <div className="deposit-item">
                                    <div className="item-header">
                                        <div className="row">
                                            <div className="col-3">
                                                <h3>Amount</h3>
                                            </div>
                                            <div className="col-9">
                                                <p className="p w-600">Available Balance : 2.03 BTC</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form">
                                        <div className="form-group">
                                            <input type="text" className="form-control" placeholder="Enter BTC" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-footer">
                            <ul className="btn-list">
                                <li><a href="#" className="btn-style" onClick={onAssetsWithdrawFundsMobileShow}>Confirm</a></li>
                            </ul>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas > */
            }
            {/* Assets Withdraw Modal End */}

            {/* Assets Withdraw Funds Modal Start */}
            {/* <Offcanvas show={assetsWithdrawFundsMobileShow} className="deposit-select-wallet-modal h-402" onHide={onAssetsWithdrawFundsMobileClose} placement={'bottom'}>
                <Offcanvas.Header closeButton>
                    //<Offcanvas.Title>Offcanvas</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="deposit-wallet-wrapper">
                        <div className="wallet-header">
                            <div className="row">
                                <div className="col-4 align-self-center">
                                    <h3 className="h3">Withdraw</h3>
                                </div>
                                <div className="col-8 align-self-center">
                                    <div className="available-funds">
                                        <h3 className="f-20">Available Funds : $39293</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-body">
                            <div className="deposit-wrapper">
                                <div className="deposit-item">
                                    <h3>Choose a bank to withdraw <br className="mobile" /> money into</h3>
                                    <SelectDropdown
                                        options={selectBanksOptions}
                                        onSelect={onSelectBanks}
                                        placeholder="Select a bank"
                                        placeholderIcon={bankIcon}
                                        className="wallet-dropdown"
                                        showSpecificItem={2} // This will pre-select specific Wallet by passing index
                                    />
                                </div>
                                <div className="deposit-item">
                                    <h3>Amount</h3>
                                    <div className="form">
                                        <div className="form-group">
                                            <div className="amount-wrapper">
                                                <div className="icon"><p className="p w-600">$</p></div>
                                                <input type="text" className="form-control black-placeholder" placeholder="Enter Amount in USD" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-footer">
                            <ul className="btn-list">
                                <li><a href="#" className="btn-style">Submit</a></li>
                            </ul>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas > */
            }
            {/* Assets Withdraw Funds Modal End */}


            {/* Mobile Popups End */}

        </div >
    )
}

export default DemoPage
